<template>
  <section>
    <div class="field">
      <label class="label">Select table</label>
      <div class="select">
        <select v-model="selectedTable">
          <option value="changes"> Changes </option>
          <option value="products"> Products </option>
          <option value="versions"> Versions </option>
        </select>
      </div>
    </div>

    <div v-if="selectedTable === 'changes' || selectedTable === 'versions'" class="field">
        <label class="label">Select product</label>
        <div class="select">
          <select v-model="productId">
            <option v-for="(product, index) in products" :key="index" v-bind:value="product.id">
              {{ product.name }}
            </option>
          </select>
        </div>
    </div>

    <div v-if="selectedTable === 'changes' && products != null && products.length > 0">
      <div v-for="(item, index) in changes" :key="index">
        <change-card  :change="item" v-on:restore="restoreChange" :action2="'restore'"></change-card>
        <br>
      </div>
    </div>

    <div v-else-if="selectedTable === 'products'">
      <div v-for="(item, index) in products" :key="index">
        <product-card :product="item" v-on:restore="restoreProduct" :action2="'restore'"></product-card>
        <br>
      </div>
    </div>

    <div v-else-if="selectedTable === 'versions'">
      <div v-for="(item, index) in versions" :key="index">
        <version-card :version="item" v-on:restore="restoreVersion" :action2="'restore'"></version-card>
        <br>
      </div>
    </div>

    <pagination class="is-centered" :urlBuilder="urlBuilder" 
                        v-bind:currentPage="page.pageNumber"
                        v-bind:lastPage="page.totalPages"/>  

    <loading :active.sync="loading" :can-cancel="false" :is-full-page="false"></loading>
  </section>
</template>

<script>
import ChangeCard from "./ChangeCard";

import ProductCard from "./ProductCard";

import VersionCard from "./VersionCard";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import Pagination from "vue-bulma-pagination/src/Pagination";

export default {
  name: "restore-partial",
  components: {
    Loading,
    ChangeCard,
    ProductCard,
    VersionCard,
    Pagination
  },
  data() {
    return {
      loading: false,
      selectedTable: "changes",
      productId: 121,
      products: [],
      changes: [],
      versions: [],

      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      }
    };
  },
  methods: {
    getProducts(deleted, take) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.HTTP.get(
          "products/" +
            (deleted ? "deleted/" : "") +
            this.page.pageNumber +
            "/" +
            take
        )
          .then(response => {
            this.loading = false;
            resolve(response);
          })
          .catch(e => {
            this.loading = false;
            reject(e);
          });
      });
    },
    getDeletedChanges() {
      this.loading = true;
      let query = "changes/product/deleted/";
      let filterType = "All";
      query +=
        this.productId +
        "/" +
        this.page.pageNumber +
        "/" +
        this.page.pageSize +
        "/" +
        filterType;

      this.HTTP.get(query)
        .then(response => {
          this.changes = response.data.entities;
          this.page = response.data.page;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getDeletedVersions() {
      this.loading = true;
      let query = "ProductVersions/product/deleted/";
      query +=
        this.productId + "/" + this.page.pageNumber + "/" + this.page.pageSize;

      this.HTTP.get(query)
        .then(response => {
          this.versions = response.data.entities;
          this.page = response.data.page;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    restoreChange(id) {
      this.loading = true;
      let query = "changes/restore/" + id;
      this.HTTP.get(query)
        .then(response => {
          this.getDeletedChanges();
        })
        .catch(e => {
          console.log(e);
        });
    },
    restoreProduct(id) {
      this.loading = true;
      let query = "products/restore/" + id;
      this.HTTP.get(query)
        .then(response => {
          this.getProducts(true, this.page.pageSize).then(response => {
            this.products = response.data.entities;
            this.page = response.data.page;
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    restoreVersion(id) {
      this.loading = true;
      let query = "ProductVersions/restore/" + id;
      this.HTTP.get(query)
        .then(response => {
          this.getDeletedVersions();
        })
        .catch(e => {
          console.log(e);
        });
    },

    urlBuilder(page) {
      return { query: { ...this.$route.query, page } }; // Changing page in location query
    },
    pushUrl() {
      this.$router.push({
        path: "admin",
        query: {
          productId: this.productId,
          page: this.page.pageNumber,
          actionId: this.$route.query.actionId
        }
      });
    }
  },
  created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    if (this.selectedTable == "changes" || this.selectedTable == "versions") {
      this.getProducts(false, 1000).then(response => {
        this.products = response.data.entities;

        if (
          response.data.entities != null &&
          response.data.entities.length > 0 &&
          (!this.$route ||
            this.$route.query.productId == "NaN" ||
            this.$route.query.productId < 0)
        )
          this.productId = response.data.entities[0].id;
        else {
          console.log(this.$route.query.productId);
          this.productId = parseInt(this.$route.query.productId);
        }
        this.page = response.data.page;
      });
    }
  },
  watch: {
    selectedTable: function(newVal) {
      if (newVal == "changes") {
        this.getProducts(false, 1000).then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
          this.productId = response.data.entities[0].id;
        });
      } else if (newVal == "products") {
        this.getProducts(true, this.page.pageSize).then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
        });
      } else if (newVal == "versions") {
        this.getProducts(false, 1000).then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
          this.productId = response.data.entities[0].id;
          this.getDeletedVersions();
        });
      }
    },
    productId: function(newVal) {
      if (this.selectedTable == "changes") this.getDeletedChanges();
      else if (this.selectedTable == "versions")
        this.getProducts(true, 1000).then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
        });
      else if (this.selectedTable == "versions") this.getDeletedVersions();
    },
    page: function(val) {
      this.pushUrl();
    },
    $route(to, from) {
      this.page.pageNumber = parseInt(to.query.page);
      this.productId = parseInt(to.query.productId);

      if (this.selectedTable == "changes") this.getDeletedChanges();
      else if (this.selectedTable == "products")
        this.getProducts(true, this.page.pageSize).then(response => {
          this.products = response.data.entities;
          this.page = response.data.page;
        });
      else if (this.selectedTable == "versions") this.getDeletedVersions();
    },
    productId: function(val) {
      this.pushUrl();
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/RestorePartial.Vue